import { breadcrumbConfig } from './breadcrumbRoutes'

export const getRouteHierarchy = (pathname: string) => {
  const segments = pathname.split('/').filter(Boolean)
  const result = []
  let currentRoutes = breadcrumbConfig
  let currentPath = ''

  for (let i = 0; i < segments.length; i++) {
    const segment = segments[i]
    currentPath += `/${segment}`

    let found = false

    for (const route of currentRoutes) {
      const routeSegments = route.path.split('/').filter(Boolean)
      const lastRouteSegment = routeSegments[routeSegments.length - 1]

      if (lastRouteSegment === segment) {
        result.push({
          ...route,
          fullPath: currentPath,
        })

        if (route.children) {
          currentRoutes = route.children
        }
        found = true
        break
      }

      if (lastRouteSegment?.startsWith(':')) {
        const paramName = lastRouteSegment.substring(1)

        let displayName = route.name
        if (route.dynamicLabels && route.dynamicLabels[paramName]) {
          displayName = route.dynamicLabels[paramName](segment)
        }

        result.push({
          ...route,
          name: displayName,
          fullPath: currentPath,
          dynamicValue: segment,
        })

        if (route.children) {
          currentRoutes = route.children
        }
        found = true
        break
      }
    }

    if (!found) {
      for (const route of breadcrumbConfig) {
        if (route.path.includes(':')) {
          const pattern = route.path.replace(/:[^/]+/g, '[^/]+')
          const regex = new RegExp(`^${pattern}$`)

          if (regex.test(currentPath)) {
            result.push({
              ...route,
              fullPath: currentPath,
            })

            if (route.children) {
              currentRoutes = route.children
            }
            found = true
            break
          }
        }
      }
    }
  }

  return result
}
